import { render } from "./guide-item.vue?vue&type=template&id=b8ebc694&scoped=true"
import script from "./guide-item.vue?vue&type=script&lang=js"
export * from "./guide-item.vue?vue&type=script&lang=js"

import "./guide-item.vue?vue&type=style&index=0&id=b8ebc694&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ebc694"]])

export default __exports__